import { useClientReservations } from '@/entities/reservation/lib/useClientReservations'
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/shared/ui/table'
import { Reservation } from '@monorepo/functions/src/types/reservations'

type ClientReservationHistoryCardProps = {
    clientId: string
    onReservationClick: (reservation: Reservation) => void
}

export const ClientReservationHistoryCard = ({ clientId, onReservationClick }: ClientReservationHistoryCardProps) => {
    const { reservations } = useClientReservations(clientId)

    return (
        <Card>
            <CardHeader>
                <CardTitle className='flex items-center justify-between'>Histórico de Reservas</CardTitle>
            </CardHeader>
            <CardContent>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Fecha</TableHead>
                            <TableHead>Mascota(s)</TableHead>
                            <TableHead>Tipo</TableHead>
                            <TableHead className='text-right'>Total</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {reservations.map(reservation => (
                            <TableRow
                                key={reservation.id}
                                className='cursor-pointer hover:bg-gray-50'
                                onClick={() => onReservationClick(reservation)}
                            >
                                <TableCell>
                                    {reservation.type === 'hotel'
                                        ? `${reservation.checkInDate} - ${reservation.checkOutDate}`
                                        : reservation.date}
                                </TableCell>
                                <TableCell>
                                    {reservation.type === 'hotel'
                                        ? reservation.pets.map(pet => pet.name).join(', ')
                                        : reservation.pet.name}
                                </TableCell>
                                <TableCell>{reservation.type === 'hotel' ? 'Hotel' : 'Peluquería'}</TableCell>
                                <TableCell className='text-right'>
                                    €{reservation.totalPrice?.toFixed(2) ?? '0'}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    )
}
